<template>
  <div class="view-container">
    <b-card
      style='min-width: 450px'
      title='Logowanie'
      header='Fanzone Admin'
    >
      <b-row>
        <b-col>
          <label>email: </label>
          <b-form-input
            type='email'
            v-model='email'
          />
        </b-col>
      </b-row>

      <b-row class='mt-3'>
        <b-col>
          <label>hasło: </label>
          <b-form-input
            type="password"
            v-model='password'
          />
        </b-col>
      </b-row>

      <hr />

      <b-row>
        <b-col>
          <div class='float-right'>
            <b-button
              variant='success'
              @click='() => handleClickLogin()'
            >
              Zaloguj
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import store from '@/store'
  
  export default {
    name: 'login',
    data() {
      return {
        email: null,
        password: null,
      };
    },
    methods: {
      handleClickLogin() {
        const { email, password } = this
        store.dispatch('login', { email, password })
      }
    },
  }
</script>

<style lang="less" scoped>
  .view-container {
    flex: 1 1 auto;
    overflow: hidden;
    position: relative;
    margin-top:0;
    display:flex;
    background: #e9ecef;
    
    .card {
      margin: auto;
      max-width: 600px;
    }
  }
</style>
